import React, { Component } from "react";
import FilterActiveIcon from "../../../icons/filteractiveicon";
import FilterIcon from "../../../icons/filtericon";
//moment import
import moment from "moment";
//Service import
import service from "../../../services";

//Loader import
import Loader from "../../loader";

//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";
import CouponsContext from './CreateContextApi';
import ReactPaginate from "react-paginate";

import serachIcon from './../../../assets/images/search.svg'
import EditIcon from "../../../icons/EditIcon";
import delet from "./../../../assets/images/delet.svg";
import PopUpCustomAll from "../create/popUpCustomAll";
import { DISCOUNT_USER_GROUP_LABELS } from "../../../cosntants";
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};
let sub;
let statusFilterList = [];

class CouponsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      getAllCouponListDetails: [],
      getAllCouponListtotaldocs: [],
      offset: 0,
      perPage: 50,
      currentPage: 0,
      searchField: '',
      deletePop: false,
      deletePopId: null,
      statusArray: [
        { assign: "Live", list: 1, value: false },
        { assign: "Disable", list: 2, value: false },
      ],
    };
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    let currentPage = localStorage.getItem('currentPage')
    if (currentPage) {
      this.setState(
        {
          offset: parseInt(localStorage.getItem("offset")),
          perPage: parseInt(localStorage.getItem("perPage")),
          currentPage: parseInt(localStorage.getItem("currentPage")),
        },
        () =>
          this.getAllCouponList(this.state.offset, this.state.perPage)
      );
    } else {
      this.setState({
        offset: 0,
        perPage: 50,
        currentPage: 0
      },
        () =>
          this.getAllCouponList(this.state.offset, this.state.perPage))
    }
    this.getAllCouponList();
    this.getAllCouponEvent();
    this.setState({
      loaderFlag: true,
    });
  };
  componentDidUpdate = () => {
  }
  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getAllCouponEvent = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|coupons|getList":
          this.setState(
            {
              getAllCouponListDetails: response.data,
              getAllCouponListtotaldocs: response.data.docs,
              pageCount: Math.ceil(
                response.data.totalDocs / this.state.perPage
              ),
            },
            () => {
              this.setState({
                loaderFlag: false,
                // pageCount: Math.ceil(
                //   response.data.totalDocs / this.state.perPage
                // ),
              });
            }
          );
          break;
        case "ticketCms|coupons|remove":
          if (!response.error) {
            this.apiserve.success("Discount deleted successfully.");
            this.getAllCouponList(this.state.offset, this.state.perPage);
          } else {
            this.apiserve.error(response.data.error);
          }
          this.setState({ deletePop: false, deletePopId: null });
          break;
      }
    });
  };

  getAllCouponList = (skip, limit, statusFilterList) => {
    var data = {
      page: skip,
      limit: limit
    }
    if (this.state.searchField.length) {
      data.filter = this.state.searchField
    }
    if (statusFilterList && statusFilterList.length) {
      data.status = statusFilterList;
    }
    this.apiserve.sendevent("ticketCms|coupons|getList", data);
  };
  editCouponListData = (item) => {
    this.props.CouponEditList(item);
    this.props.history.push({ pathname: "/discount-detail" });
  };

  deleteCoupon = (couponId) => {
    this.setState({ deletePop: true, deletePopId: couponId });
  };

  deletePopupYes = () => {
    this.apiserve.sendevent("ticketCms|coupons|remove", { couponId: this.state.deletePopId });
  };

  closeDeletePopup = () => {
    this.setState({ deletePop: false, deletePopId: null });
  };
  StatusFilter = (e, selectedInex, isClearStatusType = false) => {
    let index = selectedInex;
    let event = e && e.target && e.target.checked;
    let approvePassList = [...this.state.statusArray];
    approvePassList.forEach((key, i) => {
      if (i === index) {
        approvePassList[i].value = event;
      }
      if (isClearStatusType) {
        approvePassList[i].value = false;
        statusFilterList = [];
      }
    });
    this.setState(
      {
        ...this.state,
        statusArray: approvePassList,
        currentPage: 0,
      },
      () => {
        if (event) {
          if (index !== null) {
            statusFilterList = [
              ...statusFilterList,
              this.state.statusArray[index].list,
            ];
          }
        } else {
          if (index !== null) {
            let tempArray = statusFilterList.filter(
              (d) => d !== this.state.statusArray[index].list
            );
            statusFilterList = tempArray;
          }
        }
        this.getFilmFilter(
          this.state.offset,
          this.state.perPage,
          isClearStatusType
        );
      }
    );
  };

  getFilmFilter = (skip, limit, isClearStatusType) => {
    let data = {
      page: 1,
      limit: limit,
    };
    if (this.state.searchField.length) {
      data.filter = this.state.searchField
    }
    if (!isClearStatusType && statusFilterList && statusFilterList.length) {
      data.status = statusFilterList;
    }

    this.apiserve.sendevent("ticketCms|coupons|getList", data);
  };

  onSearchFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    }, (e) => {
      var data = {}
      data = {
        page: 1,
        limit: 50
      }
      if (this.state.searchField.length) {
        data.filter = this.state.searchField
      }
      if (statusFilterList && statusFilterList.length) {
        data.status = statusFilterList;
      }
      this.apiserve.sendevent("ticketCms|coupons|getList", data);
    })
  }

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage + 1;

    // page scroll top
    // var tbl = document.querySelector(".film_list_table");
    // tbl.scrollTo(0, 0);
    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        loaderFlag: true,
      },
      () => {
        localStorage.setItem('currentPage',this.state.currentPage)
        localStorage.setItem('offset',offset)
        localStorage.setItem('perPage',this.state.perPage)
        this.getAllCouponList(offset, this.state.perPage,statusFilterList);
      }
    );
  };

  render() {
    const { statusArray, getAllCouponListtotaldocs } = this.state;
    // const lowercasedFilter = this.state.searchField.toLowerCase();
    // const getAllCouponListtotaldocs = this.state.getAllCouponListtotaldocs.filter(item => {
    //   return Object.keys(item).some(key =>
    //     item[key].toString().toLowerCase().includes(lowercasedFilter)
    //   );
    // });
    return (
      <>
      {/* Table Search */}
      <div className="dashboard_header no_bg p_0">
        <div className="searchBlock back_date pl_15">
          <form onSubmit={e => { e.preventDefault(); }} className="m_0">
            <input
              className="bg_white"
              type="text"
              autoComplete="false"
              placeholder="Search"
              id="searchField"
              name="searchField"
              value={this.state.searchField}
              onChange={this.onSearchFilter} />
            <button type='button' style={{ pointerEvents: 'none' }}>
              <img src={serachIcon} />
            </button>
          </form>
        </div>
      </div>
      {/*End Table Search */}

      <div className="table_wrap product_list_tbl film_list_table striped_table">
        <table>
          <thead>
            <tr>
              <th>Discount</th>
              <th>Group</th>
              <th>Eventive Code</th>
              <th>Expiry Datetime (MT)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {getAllCouponListtotaldocs &&
              getAllCouponListtotaldocs.map((item, i) => (
                <tr className={item.status === 2 ? "disable" : ""} key={i}>
                  <td>
                    <strong>{item.couponCode}</strong>
                  </td>
                  <td>
                    <strong>{DISCOUNT_USER_GROUP_LABELS[item.userGroup] || item.userGroup || '-'}</strong>
                  </td>
                  <td>
                    <p>{item?.eventiveCode}</p>
                  </td>
                  <td>
                    <p>
                      {item.expiration === null ? '-' : moment.tz(item.expiration, "US/Mountain").format("MM/DD/YYYY  h:mm A")}
                    </p>
                  </td>
                  <td>
                    <span className="pointer" onClick={() => this.editCouponListData(item._id)}><EditIcon /></span>
                    <span className="pointer ml_10 d_none" onClick={() => this.deleteCoupon(item._id)} ><img src={delet} /></span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {getAllCouponListtotaldocs && getAllCouponListtotaldocs ?
        <div className="custom-pagination">
          <ReactPaginate
            previousLabel={""}
            nextLabel={""}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={this.state.currentPage}
          />
        </div>
        : ""}
      {this.state.deletePop && (
        <PopUpCustomAll
          HeaderName="Delete Discount?"
          insideDetails="You are about to delete this discount code and this action is permanent"
          insideData="Do you want to proceed?"
          popupState={this.closeDeletePopup}
          yesPopUp={this.deletePopupYes}
        />
      )}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CouponsList);